<script>
import {
  filtersComputed,
  infoMethods,
  infoDetailsMethods,
  infoDetailsComputed,
  deviceInsightsMethods,
  deviceInsightsComputed,
} from '@state/helpers'

import VisTimeline from '@components/vis-timeline'
import toggle from '@utils/design/toggle-info'

export default {
  name: 'CVisDeviceStateHistoryDetailTimeline',

  components: {
    VisTimeline,
  },

  props: {
    deviceEvents: {
      type: Array,
      default: () => [],
    },
    conditions: {
      type: Array,
      default: () => [],
    },
    cycles: {
      type: Array,
      default: () => [],
    },
    activities: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      scrollWindow: null,

      events: ['rangechange', 'rangechanged', 'select', 'doubleClick', 'timechanged'],

      groups: [
        {
          id: 'Running',
          content: 'Running',
        },
        {
          id: 'Hold',
          content: 'Hold',
        },
        {
          id: 'Idle',
          content: 'Idle',
        },
        {
          id: 'Activity',
          content: 'ACTIVITY',
        },
        {
          id: 'Events',
          content: 'CYCLE',
        },
      ],

      options: {
        align: 'left',
        clickToUse: true,
        editable: false,
        stack: false,
        showCurrentTime: true,
        zoomMin: 6000,
        max: new Date(this.deviceEvents[0].end),
        min: new Date(this.deviceEvents[this.deviceEvents.length - 1].start),
        zoomMax: 86400000,
        margin: {
          axis: 7,
          item: {
            vertical: 10,
          },
        },
      },
    }
  },

  computed: {
    ...filtersComputed,
    ...infoDetailsComputed,
    ...deviceInsightsComputed,

    allEvents: function() {
      return [
        ...this.conditions,
        ...this.cycles,
        ...this.deviceEvents,
        ...this.activities,
      ]
    },
  },

  mounted: function() {
    this.scrollWindow = document.getElementsByClassName('ps-container')
    this.changeDeviceActivities({ reset: true })
    this.setInfo({ details: true })
  },

  methods: {
    ...infoMethods,
    ...infoDetailsMethods,
    ...deviceInsightsMethods,

    supressScroll: function() {
      if (this.scrollWindow) {
        this.scrollWindow[0].style.position = 'static'
      }
    },

    enableScroll: function(e) {
      if (this.scrollWindow) {
        this.scrollWindow[0].style.position = 'absolute'
      }
      this.$refs.timeline.redraw()
    },

    elementSelected: function(e, i) {
      this.setInfo({ details: true })

      // Look for DeviceEvent Id
      let element = this.deviceEvents.find((element) => {
        return element.id === e.items[0]
      })

      if (element) {
        this.selectDetailsDefault({
          defaultObject: element,
          detailsType: 'device-state-history-details',
        })

        toggle(true)
      } else {
        // Look for ConditionId

        element = this.conditions.find((element) => {
          return element.id === e.items[0]
        })

        if (element) {
          this.selectDetailsDefault({
            defaultObject: { condition: element, firstDeviceEvent: this.deviceEvents[0] },
            detailsType: 'device-state-history-details-condition',
          })

          toggle(true)
        }
      }
    },

    elementDblClicked: function(e) {
      if (
        this.changedDeviceActivities.length > 0 &&
        this.changedDeviceActivities.length <= 1 &&
        e.time.getTime() >
          this.changedDeviceActivities[this.changedDeviceActivities.length - 1].getTime()
      ) {
        this.addTimelineActivityCustomTime(e)
      } else if (this.changedDeviceActivities.length === 0) {
        this.addTimelineActivityCustomTime(e)
      }
    },

    addTimelineActivityCustomTime: function(e) {
      this.$refs.timeline.addCustomTime(e.time, e.time)

      this.changeDeviceActivities({ deviceActivityTime: [e.time] })

      if (this.changedDeviceActivities.length >= 2) {
        this.setInfo({ details: true })

        this.selectDetailsDefault({
          defaultObject: { values: this.changedDeviceActivitiesAsObjectArray },
          detailsType: 'interact-activity-historical',
        })

        toggle(true)
      }
    },

    timeChanged: function(e) {
      this.$refs.timeline.setCustomTime(e.id, e.id)
      console.log(e, 'this' + this.changedDeviceActivities)
    },
  },
}
</script>

<template>
  <div v-if="deviceEvents && groups && options" style="min-height:265px;">
    <VisTimeline
      ref="timeline"
      :items="allEvents"
      :groups="groups"
      :options="options"
      :events="events"
      @rangechange="supressScroll"
      @rangechanged="enableScroll"
      @select="elementSelected"
      @double-click="elementDblClicked"
      @timechanged="timeChanged"
    />
  </div>
</template>
